const translations = {
    sub: 'Faster, cleaner, redesigned for you.',
    title: 'Meet the new AcreConnect',
    tryItNow: 'Try it now'
};

export default translations;
